// React
import React, { useState, useEffect } from 'react';

// Form
import { Formik } from 'formik';

// Component
import { Modal } from 'react-bootstrap';
import { TableNumber } from 'utilities';

// Form
import * as Yup from 'yup';

// API
import Axios from 'axios';
import {
  CRUDLayout,
  Input,
  InputSearch,
  SelectSearch,
  Switch,
  CreateButton,
  ActionButton,
  DataStatus,
  CreateModal,
  UpdateModal,
  DeleteModal,
  UpdateButton,
  DeleteButton,
  Alert,
  Pagination,
  THead,
  Tr,
  ThFixed,
  TBody,
  TdFixed,
  Td,
  Th,
  ExportButton,
} from 'components';
import { ItemPrelimApi } from 'api';
import FileSaver from 'file-saver';
import { useIsGuest } from 'hooks';

const ItemPrelim = ({ setNavbarTitle }) => {
  // Title
  const title = 'Item Prelim';
  const isGuest = useIsGuest();

  // STATE LOADING
  const [isLoading, setIsLoading] = useState(true);

  // STATE SEARCHING
  const [isSearching, setIsSearching] = useState(false);
  const [searchKey, setSearchKey] = useState('');

  // MODALS SHOW STATE
  const [isCreateForm, setIsCreateForm] = useState(false); // MODAL TAMBAH STATE
  const [isUpdateForm, setIsUpdateForm] = useState(false); // MODAL UPDATE STATE
  const [isDeleteData, setIsDeleteData] = useState(false); // MODAL HAPUS STATE

  // STATE DATA UPAH
  const [data, setData] = useState([]);
  // STATE UNTUK MENAMPUNG DATA FORM YANG DIPILIH
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [dataLength, setDataLength] = useState(10);
  const [totalData, setTotalData] = useState('');
  // STATE MENAMPUNG DATA YANG AKAN DI UPDATE
  const [updateData, setUpdateData] = useState([]);
  // STATE MENAMPUNG DATA YANG AKAN DI HAPUS
  const [deleteData, setDeleteData] = useState([]);

  // STATE MENAMPUNG GENERATE KODE ITEM
  const [kodeItem, setKodeItem] = useState([]);
  // STATE MENAMPUNG DATA SATUAN SELECT SEARCH
  const [satuanData, setSatuanData] = useState([]);
  const [satuanWaktuData, setSatuanWaktuData] = useState([]);
  const [kelompokData, setKelompokData] = useState([]);

  // ALERT STATE
  const [showAlert, setShowAlert] = useState(false);
  // KONFIGURASI ALERT
  const [alertConfig, setAlertConfig] = useState({
    variant: 'primary',
    text: '',
  });

  // FUNCTION GET DATA DARI SERVER
  const getData = () => {
    setIsLoading(true);
    setIsSearching(false);

    Axios.all([
      ItemPrelimApi.getPage(page, dataLength, searchKey),
      ItemPrelimApi.getKelompok(),
      ItemPrelimApi.getSatuan(),
      ItemPrelimApi.getSatuanWaktu(),
      ItemPrelimApi.generateKodeItem(),
    ])
      .then(
        Axios.spread((res, kelompok, satuan, satuan_waktu, kodeItem) => {
          setData(res.data.data);
          setKelompokData(kelompok.data.data);
          setSatuanData(satuan.data.data);
          setSatuanWaktuData(satuan_waktu.data.data);
          setKodeItem(kodeItem.data.data);
          setTotalPage(res.data.total_page);
          setTotalData(res.data.data_count);
        })
      )
      .catch((err) => alert(`Tidak dapat memuat data (${err})`))
      .finally(() => {
        if (searchKey !== '') {
          setAlertConfig({
            variant: 'primary',
            text: `Hasil Pencarian : ${searchKey}`,
          });
          setShowAlert(true);
        }
        setIsLoading(false);
      });
  };

  // FUNCTION UBAH SWITCH SHOW/HIDE STATUS
  const changeDataStatus = (status, id_item_buaso) => {
    setIsLoading(true);

    const onLoadedSuccess = () => {
      setIsSearching(false);
      setAlertConfig({
        variant: 'primary',
        text: 'Ubah status data berhasil',
      });
      setShowAlert(true);
    };

    const onLoadedFailed = () => {
      setIsSearching(false);
      setAlertConfig({
        variant: 'danger',
        text: 'Ubah status data gagal',
      });
      setShowAlert(true);
    };

    status === true
      ? ItemPrelimApi.show({ id_item_buaso })
          .then(() => onLoadedSuccess())
          .catch(() => onLoadedFailed())
          .finally(() => getData())
      : ItemPrelimApi.hide({ id_item_buaso })
          .then(() => onLoadedSuccess())
          .catch(() => onLoadedFailed())
          .finally(() => getData());
  };

  // ON COMPONENT MOUNT
  useEffect(() => {
    setNavbarTitle(title); // SET JUDUL NAVBAR
    getData(); // GET DATA DARI SERVER

    return () => {
      setIsLoading(false);
      setIsSearching(false);
    };
    // eslint-disable-next-line
  }, [setNavbarTitle, page, dataLength, searchKey]);

  // FORMIK VALIDATION SCHEMA DENGAN YUP VALIDATION
  const formValidationSchema = Yup.object().shape({
    nama_item: Yup.string()
      // .test("checkNama", "Nama tidak dapat digunakan", (value) =>
      //   ItemPrelimApi.single("nama_item", value)
      //     .then(() => false)
      //     .catch(() => true)
      // )
      .required('Masukkan Nama Item Prelim'),
    // keterangan: Yup.string().required("Masukkan Keterangan"),
    id_satuan: Yup.string().required('Pilih Satuan'),
    id_kelompok: Yup.string().required('Pilih Kelompok'),
  });

  // MODAL TAMBAH COMPONENT
  const TambahModal = () => {
    // FORMIK INITIAL VALUES
    const formInitialValues = {
      id_buaso: '6', // SET ID BUASO UPAH
      id_kelompok: null,
      kode_item: kodeItem,
      nama_item: '',
      keterangan: '',
      id_satuan: '',
      id_satuan_beli: null,
      id_satuan_waktu: null,
    };

    // KIRIM DATA BARU KE SERVER
    const formSubmitHandler = (values) => {
      ItemPrelimApi.create(values)
        .then((res) => {
          // SUCCESS ALERT
          setAlertConfig({
            variant: 'primary',
            text: 'Tambah data berhasil!',
          });
        })
        .catch((err) => {
          // const errMsg = Object.values(err.response?.data?.error) ?? []
          // ERROR ALERT
          setAlertConfig({
            variant: 'danger',
            text: `Tambah data gagal! (${err.response.data.message})`,
            // text: `Tambah data gagal! <ul> ${errMsg.map(e => `<li>${e}</li>`).join("")} </ul>`
          });
        })
        .finally(() => {
          // CLOSE MODAL
          setIsCreateForm(false);
          // TAMPILKAN ALERT
          setShowAlert(true);
          // FETCH DATA DARI SERVER
          getData();
        });
    };

    return (
      <CreateModal
        show={isCreateForm}
        onHide={() => setIsCreateForm(false)}
        title={title}
      >
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Modal.Body>
                <Input
                  label="BUASO"
                  type="text"
                  name="id_buaso"
                  // placeholder="Kode Item"
                  value="60 - Prelim"
                  readOnly={true}
                  onChange={handleChange}
                />

                <Input
                  label="Kode Prelim"
                  type="text"
                  name="kode_item"
                  placeholder="Kode Item"
                  value={values.kode_item}
                  // readOnly={true}
                  onChange={handleChange}
                />

                <Input
                  label="Nama Item Prelim"
                  type="text"
                  name="nama_item"
                  placeholder="Item Prelim"
                  value={values.nama_item}
                  onChange={handleChange}
                  error={errors.nama_item && touched.nama_item && true}
                  errorText={errors.nama_item}
                />

                <SelectSearch
                  label="Kelompok Prelim"
                  name="id_kelompok"
                  placeholder="Pilih Kelompok Prelim"
                  onChange={(val) => {
                    setFieldValue('id_kelompok', val.value);
                  }}
                  // MAPPING OPTIONS
                  // OPTIONS BERUPA VALUE DAN LABEL
                  option={kelompokData.map((val) => {
                    return {
                      value: val.id_kelompok,
                      label: val.nama_kelompok,
                    };
                  })}
                  defaultValue={{
                    value: updateData.id_kelompok ?? '',
                    label: 'Pilih Kelompok',
                  }}
                  error={errors.id_kelompok && touched.id_kelompok && true}
                  errorText={
                    errors.id_kelompok &&
                    touched.id_kelompok &&
                    errors.id_kelompok
                  }
                />

                <SelectSearch
                  label="Satuan Pakai"
                  name="id_satuan"
                  placeholder="Pilih Satuan Pakai"
                  onChange={(val) => {
                    setFieldValue('id_satuan', val.value);
                  }}
                  // MAPPING OPTIONS
                  // OPTIONS BERUPA VALUE DAN LABEL
                  option={satuanData.map((val) => {
                    return {
                      value: val.id_satuan,
                      label: val.nama_satuan,
                    };
                  })}
                  defaultValue="" // default value harus berupa: {{ label: 'masukan label', value: 'masukan value' }}
                  error={errors.id_satuan && touched.id_satuan && true}
                  errorText={
                    errors.id_satuan && touched.id_satuan && errors.id_satuan
                  }
                />

                <SelectSearch
                  label="Satuan Beli"
                  name="id_satuan_beli"
                  placeholder="Pilih Satuan Beli"
                  onChange={(val) => {
                    setFieldValue('id_satuan_beli', val.value);
                  }}
                  // MAPPING OPTIONS
                  // OPTIONS BERUPA VALUE DAN LABEL
                  option={satuanData.map((val) => {
                    return {
                      value: val.id_satuan,
                      label: val.nama_satuan,
                    };
                  })}
                  defaultValue="" // default value harus berupa: {{ label: 'masukan label', value: 'masukan value' }}
                  error={
                    errors.id_satuan_beli && touched.id_satuan_beli && true
                  }
                  errorText={
                    errors.id_satuan_beli &&
                    touched.id_satuan_beli &&
                    errors.id_satuan_beli
                  }
                />

                {/* <SelectSearch
                  label="Satuan Waktu"
                  name="id_satuan_waktu"
                  placeholder="Pilih Satuan Waktu"
                  onChange={(val) => {
                    setFieldValue("id_satuan_waktu", val.value);
                  }}
                  // MAPPING OPTIONS
                  // OPTIONS BERUPA VALUE DAN LABEL
                  option={satuanWaktuData.map((val) => {
                    return {
                      value: val.id_satuan,
                      label: val.nama_satuan,
                    };
                  })}
                  defaultValue="" // default value harus berupa: {{ label: 'masukan label', value: 'masukan value' }}
                  error={errors.id_satuan_waktu && touched.id_satuan_waktu && true}
                  errorText={
                    errors.id_satuan_waktu && touched.id_satuan_waktu && errors.id_satuan_waktu
                  }
                /> */}

                <Input
                  label="Keterangan"
                  type="text"
                  name="keterangan"
                  placeholder="Keterangan"
                  value={values.keterangan}
                  onChange={handleChange}
                  error={errors.keterangan && touched.keterangan && true}
                  errorText={errors.keterangan}
                />
              </Modal.Body>
              <Modal.Footer>
                <div className="d-flex justify-content-end">
                  <ActionButton
                    type="submit"
                    variant="primary"
                    text="Tambah"
                    className="mt-2 px-4"
                    loading={isSubmitting}
                  />
                </div>
              </Modal.Footer>
            </form>
          )}
        </Formik>
      </CreateModal>
    );
  };

  // MODAL UBAH COMPONENT
  const UbahModal = () => {
    const formInitialValues = {
      id_item_buaso: updateData.id_item_buaso,
      id_buaso: updateData.id_buaso, // SET ID BUASO UPAH
      id_kelompok: updateData.id_kelompok,
      kode_item: updateData.kode_item,
      nama_item: updateData.nama_item,
      keterangan: updateData.keterangan,
      id_satuan: updateData.id_satuan,
      id_satuan_beli: updateData.id_satuan_beli,
      id_satuan_waktu: updateData.id_satuan_waktu,
    };

    // KIRIM UPDATE DATA KE SERVER
    const formSubmitHandler = (values) => {
      ItemPrelimApi.update(values)
        .then((res) => {
          // SUCCESS ALERT
          setAlertConfig({
            variant: 'primary',
            text: 'Ubah data berhasil!',
          });
        })
        .catch((err) => {
          // const errMsg = Object.values(err.response?.data?.error) ?? []
          // ERROR ALERT
          setAlertConfig({
            variant: 'danger',
            text: `Ubah data gagal! (${err.response.data.message})`,
            // text: `Ubah data gagal! <ul> ${errMsg.map(e => `<li>${e}</li>`).join("")} </ul>`
          });
        })
        .finally(() => {
          // CLOSE UPDATE MODAL FORM
          setIsUpdateForm(false);
          // SHOW ALERT
          setShowAlert(true);
          // FETCH DATA DARI SERVER
          getData();
        });
    };

    return (
      <UpdateModal
        show={isUpdateForm}
        onHide={() => setIsUpdateForm(false)}
        title={title}
      >
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Modal.Body>
                <Input
                  label="BUASO"
                  type="text"
                  name="id_buaso"
                  // placeholder=""
                  value="60 - Prelim"
                  readOnly={true}
                  onChange={handleChange}
                />

                <Input
                  label="Kode Prelim"
                  type="text"
                  name="kode_item"
                  placeholder="Kode Item"
                  value={values.kode_item}
                  // readOnly={true}
                  onChange={handleChange}
                />

                <Input
                  label="Nama Item Prelim"
                  type="text"
                  name="nama_item"
                  placeholder="Item Prelim"
                  value={values.nama_item}
                  onChange={handleChange}
                  error={errors.nama_item && touched.nama_item && true}
                  errorText={errors.nama_item}
                />

                <SelectSearch
                  label="Kelompok Prelim"
                  name="id_kelompok"
                  placeholder="Pilih Kelompok Prelim"
                  onChange={(val) => {
                    setFieldValue('id_kelompok', val.value);
                  }}
                  // MAPPING OPTIONS
                  // OPTIONS BERUPA VALUE DAN LABEL
                  option={kelompokData.map((val) => {
                    return {
                      value: val.id_kelompok,
                      label: val.nama_kelompok,
                    };
                  })}
                  defaultValue={{
                    value: values.id_kelompok ?? '',
                    label:
                      values.id_kelompok === ''
                        ? 'Pilih Kelompok'
                        : kelompokData.find(
                            (val) => val.id_kelompok === values.id_kelompok
                          )?.nama_kelompok ?? 'Pilih Kelompok',
                  }}
                  error={errors.id_kelompok && touched.id_kelompok && true}
                  errorText={
                    errors.id_kelompok &&
                    touched.id_kelompok &&
                    errors.id_kelompok
                  }
                />

                <SelectSearch
                  label="Satuan Pakai"
                  name="id_satuan"
                  placeholder="Pilih Satuan Pakai"
                  onChange={(val) => {
                    setFieldValue('id_satuan', val.value);
                  }}
                  // MAPPING OPTIONS
                  // OPTIONS BERUPA VALUE DAN LABEL
                  option={satuanData.map((val) => {
                    return {
                      value: val.id_satuan,
                      label: val.nama_satuan,
                    };
                  })}
                  defaultValue={{
                    value: updateData.id_satuan ?? '',
                    label:
                      updateData.id_satuan === ''
                        ? 'Pilih Satuan'
                        : satuanData.find(
                            (val) => val.id_satuan === updateData.id_satuan
                          )?.nama_satuan ?? 'Pilih Satuan',
                  }}
                  error={errors.id_satuan && touched.id_satuan && true}
                  errorText={
                    errors.id_satuan && touched.id_satuan && errors.id_satuan
                  }
                />

                <SelectSearch
                  label="Satuan Beli"
                  name="id_satuan_beli"
                  placeholder="Pilih Satuan Beli"
                  onChange={(val) => {
                    setFieldValue('id_satuan_beli', val.value);
                  }}
                  // MAPPING OPTIONS
                  // OPTIONS BERUPA VALUE DAN LABEL
                  option={satuanData.map((val) => {
                    return {
                      value: val.id_satuan,
                      label: val.nama_satuan,
                    };
                  })}
                  defaultValue={{
                    value: updateData.id_satuan_beli ?? '',
                    label:
                      updateData.id_satuan_beli === ''
                        ? 'Pilih Satuan'
                        : satuanData.find(
                            (val) => val.id_satuan === values.id_satuan_beli
                          )?.nama_satuan ?? 'Pilih Satuan',
                  }}
                  error={
                    errors.id_satuan_beli && touched.id_satuan_beli && true
                  }
                  errorText={
                    errors.id_satuan_beli &&
                    touched.id_satuan_beli &&
                    errors.id_satuan_beli
                  }
                />

                {/* <SelectSearch
                  label="Satuan Waktu"
                  name="id_satuan_waktu"
                  placeholder="Pilih Satuan Waktu"
                  onChange={(val) => {
                    setFieldValue("id_satuan_waktu", val.value);
                  }}
                  // MAPPING OPTIONS
                  // OPTIONS BERUPA VALUE DAN LABEL
                  option={satuanWaktuData.map((val) => {
                    return {
                      value: val.id_satuan,
                      label: val.nama_satuan,
                    };
                  })}
                  defaultValue={{
                    value: updateData.id_satuan_waktu ?? "",
                    label:
                      updateData.id_satuan_waktu === ""
                        ? "Pilih Satuan"
                        : satuanData.find((val) => val.id_satuan === values.id_satuan_waktu)
                            ?.nama_satuan ?? "Pilih Satuan",
                  }}
                  error={errors.id_satuan_waktu && touched.id_satuan_waktu && true}
                  errorText={
                    errors.id_satuan_waktu && touched.id_satuan_waktu && errors.id_satuan_waktu
                  }
                /> */}

                <Input
                  label="Keterangan"
                  type="text"
                  name="keterangan"
                  placeholder="Keterangan"
                  value={values.keterangan}
                  onChange={handleChange}
                  error={errors.keterangan && touched.keterangan && true}
                  errorText={errors.keterangan}
                />
              </Modal.Body>
              <Modal.Footer>
                <div className="d-flex justify-content-end">
                  <ActionButton
                    type="submit"
                    variant="success"
                    text="Ubah"
                    className="mt-2 px-4"
                    loading={isSubmitting}
                  />
                </div>
              </Modal.Footer>
            </form>
          )}
        </Formik>
      </UpdateModal>
    );
  };

  // MODAL HAPUS COMPONENT
  const HapusModal = () => {
    // SET DATA ID YANG DIHAPUS
    const deleteValue = { id_item_buaso: deleteData.id_item_buaso };

    // MENANGANI DELETE BUTTON LOADING
    const [btnLoading, setBtnLoading] = useState(false);

    // DELETE DATA DARI SERVER
    const deleteDataHandler = () => {
      setBtnLoading(true);
      ItemPrelimApi.delete(deleteValue)
        .then(() => {
          // KONFIGURASI ALERT
          setAlertConfig({
            variant: 'primary',
            text: 'Hapus data berhasil!',
          });
        })
        .catch((err) => {
          // KONFIGURASI ALERT
          setAlertConfig({
            variant: 'danger',
            text: `Hapus data gagal!(${err.response.data.message})`,
          });
        })
        .finally(() => {
          // CLOSE MODAL
          setIsDeleteData(false);
          // TAMPIL ALERT
          setShowAlert(true);
          // FETCH DATA DARI SERVER
          getData();
        });
    };

    return (
      <DeleteModal
        show={isDeleteData}
        onHide={() => setIsDeleteData(false)}
        loading={btnLoading}
        onConfirm={deleteDataHandler}
        title={title}
      >
        <div>Kode Prelim : {deleteData.kode_item}</div>
        <div>Nama Item Prelim : {deleteData.nama_item}</div>
      </DeleteModal>
    );
  };

  // TABLE COMPONENT
  const Table = () => {
    return (
      <>
        <CRUDLayout.Table>
          <THead>
            <Tr>
              <ThFixed>No</ThFixed>
              {!isGuest && <ThFixed>Aksi</ThFixed>}
              <Th>Kode Prelim</Th>
              <Th>Nama Item Prelim</Th>
              <Th>Kelompok Prelim</Th>
              <Th>Satuan Pakai</Th>
            </Tr>
          </THead>
          <TBody>
            {data.map((val, index) => {
              return (
                <Tr key={val.id_item_buaso}>
                  <TdFixed>{TableNumber(page, dataLength, index)}</TdFixed>
                  {!isGuest && (
                    <TdFixed>
                      <div className="d-flex justify-content-center">
                        <UpdateButton
                          onClick={() => {
                            setUpdateData(val);
                            setIsUpdateForm(true);
                          }}
                        />
                        <DeleteButton
                          onClick={() => {
                            setDeleteData(val);
                            setIsDeleteData(true);
                          }}
                        />

                        <Switch
                          id={(index + 1).toString()}
                          checked={val.is_hidden ? false : true}
                          onChange={() =>
                            changeDataStatus(val.is_hidden, val.id_item_buaso)
                          }
                        />
                      </div>
                    </TdFixed>
                  )}
                  <TdFixed>{val.kode_item}</TdFixed>
                  <Td>{val.nama_item}</Td>
                  <Td>{val.nama_kelompok}</Td>
                  <Td>{val.nama_satuan}</Td>
                </Tr>
              );
            })}
          </TBody>
        </CRUDLayout.Table>
        {!isSearching && (
          <Pagination
            dataLength={dataLength}
            dataPage={
              totalData <= 10
                ? data.length
                : data.map(
                    (res, index) =>
                      index === data.length - 1 &&
                      TableNumber(page, dataLength, index)
                  )
            }
            dataNumber={data.map(
              (res, index) =>
                index === 0 && TableNumber(page, dataLength, index)
            )}
            dataCount={totalData}
            onDataLengthChange={(e) => {
              setDataLength(e.target.value);
              setPage(1);
            }}
            currentPage={page}
            totalPage={totalPage}
            onPaginationChange={({ selected }) => setPage(selected + 1)}
          />
        )}
      </>
    );
  };

  return (
    <CRUDLayout>
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="d-flex mb-3">
            <InputSearch
              onChange={(e) => {
                setTimeout(() => {
                  setSearchKey(e.target.value);
                  setPage(1);
                }, 1000);
              }}
              onSubmit={(e) => e.preventDefault()}
            />
          </div>
        </CRUDLayout.HeadSearchSection>

        {/* Button Section */}
        <CRUDLayout.HeadButtonSection>
          {/* Button Tambah */}
          <ExportButton
            onClick={() => {
              setIsLoading(true);
              ItemPrelimApi.export()
                .then((val) => {
                  const { REACT_APP_FILE_BASE_URL } = process.env;

                  // const urlFile = REACT_APP_FILE_BASE_URL + val.data.file;
                  const urlFile = REACT_APP_FILE_BASE_URL + val.data.file;
                  FileSaver.saveAs(urlFile, val.data.file);
                })
                .catch((res) => alert(res))
                .finally(() => {
                  setIsLoading(false);
                });
            }}
          />
          <CreateButton onClick={() => setIsCreateForm(true)} />
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {/* Alert */}
      <Alert
        show={showAlert}
        showCloseButton={true}
        variant={alertConfig.variant}
        text={alertConfig.text}
        onClose={() => setShowAlert(false)}
      />

      {isLoading ? (
        <DataStatus loading={isLoading} text="Memuat Data" />
      ) : !Array.isArray(data) ? (
        <DataStatus text="Tidak dapat memuat data" />
      ) : data.length > 0 ? (
        <Table />
      ) : (
        <DataStatus text="Tidak ada data" />
      )}

      {/* MODAL */}
      <TambahModal />
      <UbahModal />
      <HapusModal />
    </CRUDLayout>
  );
};

export default ItemPrelim;
